__turbopack_context__.v({
  "centerAmounts": "Progress-module__4V_mbq__centerAmounts",
  "container": "Progress-module__4V_mbq__container",
  "donationContainer": "Progress-module__4V_mbq__donationContainer",
  "goalContainer": "Progress-module__4V_mbq__goalContainer",
  "label": "Progress-module__4V_mbq__label",
  "number": "Progress-module__4V_mbq__number",
  "numbersContainer": "Progress-module__4V_mbq__numbersContainer",
  "verticalLine": "Progress-module__4V_mbq__verticalLine",
});
